import './modal.scss'

import React, { Fragment, ReactNode } from 'react'

import { createPortal } from 'react-dom'

interface ModalProps {
  toggleModal?(): void
  children?: ReactNode
}

export default class Modal extends React.PureComponent<ModalProps> {
  private modal: HTMLDivElement | null

  componentDidMount = () => {
    document.body.addEventListener('click', this.onClickOutside, false)
  }

  componentWillUnmount = () => {
    document.body.removeEventListener('click', this.onClickOutside, false)
  }

  onClickOutside = ({ target }) => {
    if (this.modal && !this.modal?.contains(target) && this.props.toggleModal) {
      this.props.toggleModal()
    }
  }

  render = () =>
    createPortal(
      <Fragment>
        <div className="overlay" />
        <div
          className="modal"
          ref={node => {
            this.modal = node
          }}
        >
          {this.props.children}
        </div>
      </Fragment>,
      document.body,
    )
}
